import React from "react";

function Footer() {
  return (
    <footer>
      <div className="row">
        <div className="footer-content">
          <h2 data-aos="zoom-out">Danny Quan</h2>
          <div className="footer-content" data-aos="fade-right">
            <ul className="contact-info">
              <li>Address: Techiman / Bono East</li>
              <li>Phone: +233 54 514 3000 / +233 50 683 1839</li>
              <li>
                {/*Email icon here */}
                <a href="mailto:danielsah118@gmail.com">
                  Send Me an Email
                </a>
              </li>
            </ul>
          </div>
          <div className="social-links" data-aos="fade-left">
            <h4>Get in touch</h4>
            <ul className="link-items">
              <li>
                <a href="https://instagram.com/dannyquan14" target='_blank' rel="noreferrer">
                  <ion-icon name="logo-instagram"></ion-icon>
                </a>
              </li>
              <li>
                <a href="https://facebook.com/christ101020" target='_blank' rel="noreferrer">
                  <ion-icon name="logo-facebook"></ion-icon>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/CreativesQuan" target='_blank' rel="noreferrer">
                  <ion-icon name="logo-twitter"></ion-icon>
                </a>
              </li>
              <li>
                <a href="https://github.com/danny-quan" target='_blank' rel="noreferrer">
                  <ion-icon name="logo-github"></ion-icon>
                </a>
              </li>
              <li>
                <a href="https://linkedin.com/in/daniel-sah-kwadwo-9a79271a6" target='_blank' rel="noreferrer">
                  <ion-icon name="logo-linkedin"></ion-icon>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
